import { fetchAPI } from "packs/api";

document.querySelectorAll("a[href^='https://www.pepper.ru/visit'], a[href^='https://live.pepper.ru/visit'], a[href^='https://staging.pepper.ru/visit'], a[href^='http://localhost:4000/visit'], a[href^='https://www.pepper.ru/links'], a[href^='https://live.pepper.ru/links'], a[href^='https://staging.pepper.ru/links'], a[href^='http://localhost:4000/links']").forEach(link => {
    link.addEventListener("mousedown", function (e) {
        if (e.which == 3) {
            let device = 'desktop';
            if (is_device_mobile()) {
                device = 'mobile';
            }
            let current_page_url = window.location.href;
            let value = this.getAttribute('href');
            let topic_permalink = this.dataset.permalink;
            let user_value = 0;
            let utm_parameter = Cookies.get('pp_dd_utm_campaign');
            let current_user_id = document.getElementById("CurrentUserID");

            if (current_user_id) {
                user_value = current_user_id.value;
            }

            if (!utm_parameter) {
                let t0 = `ts=direct&dduid=${user_value}&client=${device}`;
                value += value.includes('?') ? `&${t0}` : `?${t0}`;
            }

            if (utm_parameter) {
                let utm_medium = Cookies.get('pp_dd_utm_medium');
                let utm_source = Cookies.get('pp_dd_utm_source');
                let gclid = Cookies.get('pp_dd_gclid');
                let fbclid = Cookies.get('pp_dd_fbclid');

                if (fbclid) {
                    let t1 = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&fbclid=${fbclid}`;
                    value += value.includes('?') ? `&${t1}` : `?${t1}`;
                }

                if (gclid) {
                    let t2 = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&gclid=${gclid}`;
                    value += value.includes('?') ? `&${t2}` : `?${t2}`;
                } else {
                    let t3 = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}`;
                    value += value.includes('?') ? `&${t3}` : `?${t3}`;
                }
            }

            window.open(value, "_blank");
            update_outbound_click(topic_permalink);
            return false;
        }
        return true;
    });

    link.addEventListener("click", function () {
        let device = 'desktop';
        if (is_device_mobile()) {
            device = 'mobile';
        }
        let current_page_url = window.location.href;
        let value = this.getAttribute('href');
        let topic_permalink = this.dataset.permalink;
        let user_value = 0;
        let utm_parameter = Cookies.get('pp_dd_utm_campaign');
        let current_user_id = document.getElementById("CurrentUserID");

        if (current_user_id) {
            user_value = current_user_id.value;
        }

        if (!utm_parameter) {
            let t0 = `ts=direct&dduid=${user_value}&client=${device}`;
            value += value.includes('?') ? `&${t0}` : `?${t0}`;
        }

        if (utm_parameter) {
            let utm_medium = Cookies.get('pp_dd_utm_medium');
            let utm_source = Cookies.get('pp_dd_utm_source');
            let gclid = Cookies.get('pp_dd_gclid');
            let fbclid = Cookies.get('pp_dd_fbclid');

            if (fbclid) {
                let t1 = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&fbclid=${fbclid}`;
                value += value.includes('?') ? `&${t1}` : `?${t1}`;
            }

            if (gclid) {
                let t2 = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}&gclid=${gclid}`;
                value += value.includes('?') ? `&${t2}` : `?${t2}`;
            } else {
                let t3 = `ts=Xutm_${utm_parameter}&dduid=${user_value}&client=${device}&us=${utm_source}&um=${utm_medium}`;
                value += value.includes('?') ? `&${t3}` : `?${t3}`;
            }
        }

        window.open(value, "_blank");
        update_outbound_click(topic_permalink);
        return false;
    });
});

function update_outbound_click(url) {
    fetchAPI("/update_outbound_click", "POST", { url: url }, "")
        .then(response => {
            // No action
        })
        .catch(error => {
            console.error("Request failed:", error);
        });
}

function get_current_user_id() {
    let current_user_id = document.getElementById("CurrentUserID");
    return current_user_id ? current_user_id.value : 'guest';
}

function is_device_mobile() {
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph/i.test(navigator.userAgent.substr(0, 4)));
}

function card_click() {
    document.addEventListener('click', function (event) {
        let card = event.target.closest('.deal-card, .discussion-card');
        if (card) {
            // If the clicked target is one of the excluded elements, stop further actions
            if (event.target.closest('.orange-btn, a, .bookmark-or-mute, .remove-bookmark, .unmute-post')) {
                return;
            }
            // Redirect to the URL specified in the data-permalink attribute
            window.location = `/${card.dataset.permalink}`;
        }
    });
}

window.card_click = card_click;

card_click();